/**
 * Interaction / preview modes passed from SVG interaction hooks to Outline- and ProductPreview.
 *
 * These are logic constants, not UI labels.
 */
export const OUTLINE_PREVIEW_MODE = {
  NORMAL:                 'normal', //legacy
  NORMAL_PRODUCT:         'normal-product',
  NORMAL_OUTLINE:         'normal-outline',
  SOLD:                   'sold',
  FILTERED:               'filtered',
  FILTERED_SOLD:          'filtered-sold',
  HIDDEN:                 'hidden',
  OTHER_STAGE:            'other-stage',
  OTHER_STAGE_INQUIRY:    'other_stage_inquiry',
  OTHER_STAGE_REDIRECT:   'other_stage_redirect',
  DISABLED_INACTIVE:      'disabled_inactive',
  DISABLED_SOLD_OUT:      'disabled_sold_out',
}

export const PRODUCT_PREVIEW_KIND = {
    POPOVER: 'popover',
    PANEL: 'panel',
    BOTTOM_SHEET: 'bottom_sheet',
}